import { Box, Button, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import LoadingButton from "../../../../design/wilya-loading-button";
import { Priority } from "../../../../utils/types";

interface ISectionActionsProps {
  oldData?: any;
  newData: any;
  resetChanges?: any;
  handleSave: any;
  status?: any;
  loading?: any;
  companyDataValue?: any;
  canNotSave?: boolean;
}

const SectionActions: React.FC<ISectionActionsProps> = ({
  oldData,
  newData,
  resetChanges,
  handleSave,
  status,
  loading,
  companyDataValue,
  canNotSave: externalCanNotSave,
}) => {
  const [canNotSave, setCanNotSave] = useState(false);
  const [enableSave, setEnableSave] = useState(false);
  const skillPriorities: Priority[] = useSelector(
    (state: any) => state.gatAdminConfiguration.skillPriorities
  );
  const companyFullTimeScheduleLocationSettingsOriginalValue = useSelector(
    (state: any) =>
      state.gatAdminConfiguration.getCompanyFullTimeScheduleLocationSettings
        .locationSettings
  );
  const companyFullTimeScheduleLocationSettingsSelectedValue = useSelector(
    (state: any) =>
      state.gatAdminConfiguration.updateCompanyFullTimeScheduleLocationSettings
        .selectedLocations
  );
  const companyFullTimeScheduleLocationSettingsNewValue =
    companyFullTimeScheduleLocationSettingsOriginalValue.map(
      (location: any) => {
        const selectedLocation =
          companyFullTimeScheduleLocationSettingsSelectedValue.find(
            (loc: any) => loc.id === location.locationId
          );
        return {
          ...location,
          value: !!selectedLocation,
        };
      }
    );

  const companyAbsenceManagementLocationSettings = useSelector(
    (state: any) =>
      state.gatAdminConfiguration.getCompanyAbsenceManagementLocationSettings
        .locationSettings
  );
  const companyAbsenceManagementLocationSettingsSelectedValue = useSelector(
    (state: any) =>
      state.gatAdminConfiguration.updateCompanyAbsenceManagementLocationSettings
        .selectedLocations
  );
  const companyAbsenceManagementLocationSettingsNewValue =
    companyAbsenceManagementLocationSettings.map((location: any) => {
      const selectedLocation =
        companyAbsenceManagementLocationSettingsSelectedValue.find(
          (loc: any) => loc.id === location.locationId
        );
      return {
        ...location,
        value: !!selectedLocation,
      };
    });
  useEffect(() => {
    try {
      const skillLevels = companyDataValue.skillLevels;
      const skillPriorityEnabled = newData.skillPriorityEnabled;
      const crossSkillingEnabled = newData.crossSkillingEnabled;
      if (crossSkillingEnabled && skillLevels.length === 0) {
        setCanNotSave(true);
      } else if (skillPriorityEnabled && skillPriorities.length === 0) {
        setCanNotSave(true);
      } else {
        setCanNotSave(false);
      }
    } catch (e) {
      // Do nothing
    }
  }, [companyDataValue, skillPriorities, newData]);

  useEffect(() => {
    const fullTimeSchedulingEnabled = newData.fullTimeSchedulingEnabled;
    const absenceManagementEnabled = newData.absenceManagementEnabled;
    let valuesChanged = false;
    if (
      fullTimeSchedulingEnabled &&
      JSON.stringify(companyFullTimeScheduleLocationSettingsOriginalValue) !==
        JSON.stringify(companyFullTimeScheduleLocationSettingsNewValue)
    ) {
      valuesChanged = true;
    }
    if (
      absenceManagementEnabled &&
      JSON.stringify(companyAbsenceManagementLocationSettings) !==
      JSON.stringify(companyAbsenceManagementLocationSettingsNewValue)
    ) {
      valuesChanged = true;
    }
    setEnableSave(valuesChanged);
  }, [
    companyFullTimeScheduleLocationSettingsOriginalValue,
    companyFullTimeScheduleLocationSettingsNewValue,
    companyAbsenceManagementLocationSettings,
    companyAbsenceManagementLocationSettingsNewValue,
    newData.fullTimeSchedulingEnabled,
    newData.absenceManagementEnabled,
    oldData.fullTimeSchedulingEnabled,
    oldData.absenceManagementEnabled,
  ]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-end",
        paddingTop: "16px",
        paddingBottom: "12px",
      }}
    >
      <Button
        variant="outlined"
        disabled={(JSON.stringify(oldData) === JSON.stringify(newData) && !enableSave)}
        onClick={resetChanges}
      >
        Discard all new changes
      </Button>
      <LoadingButton
        variant="contained"
        disabled={
          canNotSave ||
          externalCanNotSave ||
          (JSON.stringify(oldData) === JSON.stringify(newData) && !enableSave) ||
          loading ||
          status === "pending"
        }
        sx={{ marginLeft: "16px" }}
        loading={status === "pending" || loading}
        onClick={handleSave}
        loadingIndicator={
          <CircularProgress size={16} sx={{ color: "rgba(0, 0, 0, 0.38)" }} />
        }
      >
        Save
      </LoadingButton>
    </Box>
  );
};

export default SectionActions;
